import React, { useEffect } from "react"
import { withRouter, useParams } from "react-router-dom"
import { useSelector, connect } from "react-redux"

import {
  Col,
  UncontrolledTooltip,
  Table,
  //Button,
  Row,
  Badge
} from "reactstrap"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import BootstrapTable from "react-bootstrap-table-next"
import moment from "moment"
import { ToastContainer } from "react-toastify"
import * as teamAction from "../../store/b3BlcmF0aW9uc0/actions"
// import "./styles.scss"


const OperationsTeamScheduling = (props) => {
  const { searchBarStyle, dispatch } = props
  let { id } = useParams()
  const { SearchBar } = Search
  useEffect(() => {
    dispatch(teamAction.loadTeamSchedule(id))
  }, [1])

  const Update = useSelector(
    (specificState) => specificState.operationsFollowUp
  )
  const {
    team_list = [],

  } = Update


  //date format

  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate
  //date format from localstorage
  const authUser = localStorage.getItem("authUser")

  const dateLogin = JSON.parse(authUser)

  const setDate =
    !isEmpty(dateLogin) && dateLogin.setting && dateLogin.setting.dateFormate
      ? dateLogin.setting.dateFormate.toUpperCase()
      : !isEmpty(user) && user.setting && user.setting.dateFormate
        ? user.setting.dateFormate.toUpperCase()
        : []

  const dateFormat = !isEmpty(setDate) && setDate ? setDate : ""

  let slNo = 0
  //Data Table section
  const deliverDataTable = !isEmpty(team_list)
    ? team_list.map((data, index) => {
      const eventName = !isEmpty(data.eventDetails)?data.eventDetails.eventName:"--"
      const eventNo = !isEmpty(data.eventDetails)?data.eventDetails.eventNo:"--"
      const eventDate = !isEmpty(data.eventDetails)?
      moment(data.eventDetails.eventDate).format(dateFormat):"--"
      const startTime = !isEmpty(data.eventDetails)?data.eventDetails.startTime:"--"
      const endTime = !isEmpty(data.eventDetails)?data.eventDetails.endTime:"--"
      const venue = !isEmpty(data.eventDetails)?data.eventDetails.venueLocation:"--"
        slNo = slNo + 1
      return {
        index: index,
        leadId: data.leadId,
        sNo: slNo,
        serviceCount: !isEmpty(data.serviceDetails) ? data.serviceDetails.length : 0,
        isCommit: data.isCommit,
        eventName:eventName,
        eventNo:eventNo,
        eventDate:eventDate,
        startTime:startTime,
        endTime:endTime,
        venueLocation:venue,
        serviceDetails: data.serviceDetails
      }
    })
    : []



  //table columns
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
      editable: false,
    },
    {
      dataField: "serviceCount",
      text: "Services",
      formatter: (cellContent, row) => {
        return (
          <div className="space-between">
            <span className="badge rounded-pill bg-primary">
              {row.serviceCount}
            </span>
          </div>
        )
      },
    },
    {
      dataField: "isCommit",
      text: "Commit",
      headerStyle: {
        minWidth: "120px",
      },
      formatter: (cellContent, row) => {
        return (
          <Badge
            color={row.isCommit === true ? "success" : "danger"}
            style={{ padding: "6px", fontSize: "12px" }}
          >
            {row.isCommit === true ? "Yes" : "No"}
          </Badge>
        )
      },
    },
    {
      dataField: "eventName",
      text: "Event Name",
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },

    {
      dataField: "eventNo",
      text: "Event No",
      editable: false,
      csvExport: false,
      headerStyle: {
        minWidth: "120px",
      },
    },

    {
      dataField: "eventDate",
      text: "Event Date",
      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "startTime",
      text: "Start Time",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "endTime",
      text: "End Time",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "venueLocation",
      text: "Venue Location",
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },

  ]
  const expandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Service No
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Service Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Payment Status
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Team Shooter
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Freelancer Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Freelancer Amount
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Sub Freelancer Name
              </th>

            </tr>
          </thead>
          <tbody>
            {row && !isEmpty(row.serviceDetails) && row.serviceDetails.length > 0 ?
              row.serviceDetails.map((data, index) => {
                const serviceName = !isEmpty(data.serviceId) ? data.serviceId.serviceName : "--"
                const freelancer = !isEmpty(data) && data.teamFreelanceShooter.length > 0 ?
                  data.teamFreelanceShooter.map(m => m.freelanceMainShooterName) : []

                const freelancerName = !isEmpty(freelancer) && freelancer.length > 0 ?
                  freelancer.join(",") : "--"

                const subFreelancer = !isEmpty(data) && data.teamFreelanceShooter.length > 0 ?
                  data.teamFreelanceShooter.map(m => m.freelanceSubShooterName) : []

                const subFreelancerName = !isEmpty(subFreelancer) && subFreelancer.length > 0 ?
                  subFreelancer.join(",") : "--"

                const amount = !isEmpty(data) && data.teamFreelanceShooter.length > 0 ?
                  data.teamFreelanceShooter.map(m => m.amount) : []

                const amountValue = !isEmpty(amount) && amount.length > 0 ? amount.join(",") : "--"
                const shooterName = !isEmpty(data.teamEmployeeShooterId) ? data.teamEmployeeShooterId.empCode +"-"+ data.teamEmployeeShooterId.name:"--"
              return (
                  <tr key={index}>
                    <td>{data.serviceNo ? data.serviceNo : "--"}</td>
                    <td>{serviceName}</td>
                    <td>{data.paymentStatus ? data.paymentStatus : "--"}</td>
                    <td>{shooterName}</td>
                    <td>{freelancerName}</td>
                    <td>{amountValue}</td>
                    <td>{subFreelancerName}</td>
                  </tr>
                )
              }) : (
                <tr key={0}>
                  <td className="text-align-center" colSpan={8}>
                    No data found
                  </td>
                </tr>
              )
            }


          </tbody>
        </Table>
      </>
    ),

    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }
 
  // pagination options
  const options = {
    sizePerPage: 10,
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }
  //Modal Section


  return (
    <React.Fragment>
      <Row className="quote-head-content">
        <p className="quote-head">
          Team Scheduling Details
          <span className="quote-info">
            <i
              style={{ color: "grey" }}
              id="DeliverableInfo"
              aria-hidden="true"
              className="fa fa-info-circle ms-1"
            ></i>
            <UncontrolledTooltip placement="right" target="DeliverableInfo">
              Team Scheduling Details
            </UncontrolledTooltip>
          </span>
        </p>

        <Col md="12" lg="12" xl="12" className="mt-3">
          <PaginationProvider
            pagination={paginationFactory(options)}
            keyField="_id"
            columns={columns}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="_id"
                data={deliverDataTable}
                columns={columns}
                search
                exportCSV
              >
                {(props) => (
                  <div>
                    <Col md="12" xl="12" lg="12" sm="12" xs="12">
                      <Row className="d-flex flex-row  ">
                        <Col className="mb-3" md="4">
                          <div className="d-flex flex-row ">
                            <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                              <div
                                className="position-relative mt-7"
                                style={searchBarStyle || null}
                              >
                                <SearchBar {...props.searchProps} />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </div>{" "}
                        </Col>
                        <Col>
                          <BootstrapTable
                            {...props.baseProps}
                            responsive
                            striped={true}
                            bordered={true}
                            keyField="_id"
                            expandRow={expandRow}
                            columns={columns}
                            {...paginationTableProps}
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginTop: "5px" }}
                        className="align-items-md-center mt-30"
                      >
                        <Col className="inner-custom-pagination d-flex">
                          <div className="d-inline d-flex flex-row">
                            <SizePerPageDropdownStandalone
                              {...paginationProps}
                            />
                            <div
                              style={{
                                fontSize: "14px",
                                marginTop: "8px",
                                marginLeft: "4px",
                              }}
                            >
                              <PaginationTotalStandalone
                                {...paginationProps}
                              />
                            </div>
                          </div>
                          <div
                            className="text-md-right ms-auto"
                            style={{ zIndex: 0 }}
                          >
                            <PaginationListStandalone
                              {...paginationProps}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </div>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
        </Col>
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />



      </Row>
    </React.Fragment>
  )
}
OperationsTeamScheduling.propTypes = {
  dispatch: PropTypes.func,
  record_quotation_details: PropTypes.array,
  loading: PropTypes.any,
  success: PropTypes.any,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  csvProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OperationsTeamScheduling)
)
